import { emitShopifyEvent } from '../services/analytics.service';
import { toSHA256 } from '../services/crypto.service';
const RECOVER_HASH = '#recover';
const LOGIN_FORM_ID = 'customer_login';
const EMAIL_INPUT_SELECTOR = '.js-login-form-email';
const PASSWORD_INPUT_SELECTOR = '.js-login-form-password';
const SUBMIT_BUTTON_SELECTOR = '.js-login-form-submit-button';
const SUBMIT_SPINNER_SELECTOR = '.js-login-form-submit-spinner';
const SUBMIT_TEXT_SELECTOR = '.js-login-form-submit-text';
function getLoginSection() {
    return document.getElementById('customer-login');
}
function getRecoverSection() {
    return document.getElementById('recover-password');
}
function getRegisterSection() {
    return document.getElementById('customer-register');
}
function getLoginForm() {
    const form = document.getElementById(LOGIN_FORM_ID);
    return form instanceof HTMLFormElement ? form : null;
}
function showElement(element) {
    if (element) {
        element.style.display = '';
    }
}
function hideElement(element) {
    if (element) {
        element.style.display = 'none';
    }
}
function showRecoverPasswordForm() {
    showElement(getRecoverSection());
    hideElement(getLoginSection());
    window.location.hash = RECOVER_HASH;
}
function showLoginForm() {
    hideElement(getRecoverSection());
    hideElement(getRegisterSection());
    showElement(getLoginSection());
    window.location.hash = '';
}
function validateLoginForm() {
    const form = getLoginForm();
    if (!form) {
        return;
    }
    const inputMail = form.querySelector(EMAIL_INPUT_SELECTOR);
    const inputPassword = form.querySelector(PASSWORD_INPUT_SELECTOR);
    const btn = form.querySelector(SUBMIT_BUTTON_SELECTOR);
    if (!inputMail || !inputPassword || !btn) {
        return;
    }
    const result = !!(inputMail.value && inputPassword.value.length >= 6);
    btn.classList.toggle('complete', result);
    btn.classList.toggle('incomplete', !result);
}
function handleFieldChange() {
    validateLoginForm();
}
function setLoginSubmitLoading(form) {
    const btn = form.querySelector(SUBMIT_BUTTON_SELECTOR);
    if (!btn) {
        return;
    }
    form.querySelector(SUBMIT_SPINNER_SELECTOR)?.classList.remove('hidden');
    const textEl = form.querySelector(SUBMIT_TEXT_SELECTOR);
    const loadingText = btn.dataset.loadingText;
    if (textEl && loadingText) {
        textEl.textContent = loadingText;
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
}
async function trackLoginAnalytics(emailRaw) {
    const emailHash = await toSHA256(emailRaw);
    emitShopifyEvent('login', { emailRaw, emailHash });
    try {
        localStorage.setItem('userEmail', emailHash);
    }
    catch (e) {
        console.log(e);
    }
}
async function handleSubmit(event) {
    const form = event.currentTarget;
    if (!(form instanceof HTMLFormElement)) {
        return;
    }
    const emailInput = form.querySelector(EMAIL_INPUT_SELECTOR);
    const val = emailInput?.value;
    if (!val) {
        return;
    }
    // Block native submit synchronously so async analytics can finish before navigation.
    // Programmatic form.submit() does not re-dispatch this handler (WebKit-safe).
    event.preventDefault();
    setLoginSubmitLoading(form);
    const emailRaw = val.toLowerCase();
    try {
        await trackLoginAnalytics(emailRaw);
    }
    catch (e) {
        console.log(e);
    }
    form.submit();
}
function bindLoginForm() {
    const form = getLoginForm();
    if (!form) {
        return;
    }
    const emailInput = form.querySelector(EMAIL_INPUT_SELECTOR);
    const passwordInput = form.querySelector(PASSWORD_INPUT_SELECTOR);
    emailInput?.addEventListener('input', handleFieldChange);
    emailInput?.addEventListener('change', handleFieldChange);
    passwordInput?.addEventListener('input', handleFieldChange);
    passwordInput?.addEventListener('change', handleFieldChange);
    passwordInput?.addEventListener('keyup', handleFieldChange);
    form.addEventListener('submit', handleSubmit);
    validateLoginForm();
    // Password managers and webview autofill may populate fields after DOM ready.
    window.setTimeout(validateLoginForm, 300);
    window.setTimeout(validateLoginForm, 1000);
}
function shouldShowRecoverPanel() {
    if (window.location.hash === RECOVER_HASH) {
        return true;
    }
    return getRecoverSection()?.dataset.recoverActive === 'true';
}
function bindUIActions() {
    if (shouldShowRecoverPanel()) {
        showRecoverPasswordForm();
    }
    else {
        showLoginForm();
    }
    document.getElementById('showRecoverForm')?.addEventListener('click', (event) => {
        event.preventDefault();
        showRecoverPasswordForm();
    });
    document.getElementById('cancelRecoverForm')?.addEventListener('click', (event) => {
        event.preventDefault();
        showLoginForm();
    });
    bindLoginForm();
}
function init() {
    bindUIActions();
}
export default { init };
